$(document).ready(function() {
	console.log('custom js works');

   let ageVerify = sessionStorage.getItem('ageVerify');
   console.log(ageVerify);

   let $agePopUpCon = $('#age-pop-up-container');

   if(ageVerify) {
   		//do nothing
   	console.log('age is verified');
   } else {
   	console.log('age not verified');
   	$agePopUpCon.css("display", "flex");

   	$("#ageButtonYes").click(() => {
                sessionStorage.setItem('ageVerify', true);
                $agePopUpCon.css("display", "none");
                
            });
            $("#ageButtonNo").click(() => {
                window.location.href = 'http://google.com/';
            });

   }


   $('.multicolumn-list li').each(function () {
  const link = $(this).data('link'); // Get the data-link value
  if (link) {
    $(this).css('cursor', 'pointer'); // Change the cursor to indicate it's clickable
    $(this).on('click', function () {
      window.location.href = link; // Redirect to the link on click
    });
  }
});


  const scrollPoint = 100; // Change background after this scroll value
  window.addEventListener("scroll", function () {
    if (window.scrollY > scrollPoint) {
      $('.not-homepage-header-wrapper').addClass('scrolled');
    } else {
      $('.not-homepage-header-wrapper').removeClass('scrolled');
    }
  });




});